import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import PictureInPictureAltIcon from '@mui/icons-material/PictureInPictureAlt'
import { usePIP } from '../../hooks/usePIP'
import { TopNavBarButton } from './Buttons/TopNavBarButton'
import { IconButton } from '@material-ui/core'

export const PIPButton = ({ isMobile }) => {
  const { togglePIP, canPIP } = usePIP()

  return (
    <>
      {canPIP === true ? (
        <div data-tour="pip-button">
          {isMobile ? (
            <TopNavBarButton
              id="PIP-video-toogle-button"
              data-test="PIP-video-toogle-button"
              onClick={togglePIP}
            >
              <PIPIcon />
            </TopNavBarButton>
          ) : (
            <PIPDesktopButton
              id="PIP-video-toogle-button"
              data-test="PIP-video-toogle-button"
              onClick={togglePIP}
              size="small"
            >
              <PIPIcon />
            </PIPDesktopButton>
          )}
        </div>
      ) : null}
    </>
  )
}

const PIPDesktopButton = styled(IconButton)``

const PIPIcon = styled(PictureInPictureAltIcon)`
  color: #fff;
`

PIPButton.propTypes = {
  isMobile: PropTypes.bool.isRequired,
}
